<template>
  <div class="news_detail">
    <main class="main-content">
      <div class="breadcrumbs">
        <div class="container">
          <div class="d-flex">
            <h2>{{ news.cat }}</h2>
            <div class="ol">
              <a href="javascript:;" @click="goto('/')">首页</a>
              <a href="javascript:;" @click="goto('/news')">新闻动态</a>
              <span>{{ news.cat }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="page">
        <div class="container content">
          <div class="head">
            <div class="subtitle">{{ news.title }}</div>
            <div class="time">
              {{ news.createdAt | dateTime("YYYY年M月D日 HH:mm:ss") }}
            </div>
          </div>
          <div class="info" v-html="news.content"></div>
        </div>
      </div>
      <!-- .page -->
    </main>
  </div>
</template>
<script>
export default {
  name: "NewsDetail",
  data() {
    return {
      list: [
        { _id: 'd306933cd2c649559787ffc970edce1f', cat: '正博新闻', title: '关于正博部分产品调整的通知', createdAt: '2022-06-17 09:23:12', content: `<p>正博部分产品调整，其中正博京东小包降价，生效日期6.24日</p><p><a href="javascript:;">点击下载《正博产品手册》</a></p>` },
        {
          _id: '38eb86df40fc4f14b9facfe31b7649c1', cat: '正博新闻', title: '关于E邮宝郑州（普+特）-敦煌上线的通知', createdAt: '2022-06-02 16:25:02', content: `<div id="right">
    <div class="n_text">
      <strong>尊敬的敦煌网商户：</strong><br>
<br>
为了给您更好的物流体验，敦煌网上线了一条优质线路——E邮宝郑州（普+特）-DF，具体产品说明如下：<br>
<br>
<strong>1.线路介绍</strong><br>
<br>
<img alt="" src="http://www.dhresource.com/0x0/f2/albu/g22/M00/F7/1F/rBVaEmKYcdeAD6ZqAADt5RNfyp0051.jpg" style="width: 750px; height: 99px;"><br>
<br>
<strong>2.可发国家</strong><br>
<br>
美国、澳大利亚、加拿大、卢森堡、挪威、以色列、奥地利、波兰、沙特阿拉伯、土耳其、匈牙利、新西兰、乌克兰、印尼、意大利、爱尔兰、巴西、比利时、丹麦、芬兰、哈萨克斯坦、荷兰、马来西亚、葡萄牙、瑞典、瑞士、泰国、希腊、新加坡、越南、中国香港、墨西哥、俄罗斯、德国、英国、西班牙、韩国、法国、日本<br>
<br>
<strong>3.计费方式</strong><br>
<br>
(1)以仓库实际称重后，平台显示运费为准，发货前可以点击链接：<u><a href="http://www.dhlink.com" target="_blank"><span style="color:#00f;">http://www.dhlink.com</span></a></u> 测算运费。<br>
<br>
<strong>4.走货属性：</strong><br>
<br>
(1)禁限寄物品: 所有电池与含电产品、液体粉末等航空禁止运输物品<br>
<br>
(2)严禁邮寄违反中国法律、国际航空运输协会（IATA）禁限寄物品条例及当地法例的物品。比如：<br>
<br>
1、有爆炸性、易燃性、腐蚀性、毒性、强酸碱性和放射性的各种危险物品。如雷管、火药、爆竹、汽油、酒精、煤油、桐油、生漆、火柴、农药等。<br>
<br>
2、麻醉药物和精神药品。如鸦片、吗啡、可卡因（高根）、恰特草、芬太尼、卡芬太尼等。<br>
<br>
3、国家法令禁止流通或寄递的物品。如军火武器、手枪、气枪、手枪配件、本国或外国货币等<br>
<br>
4、容易腐烂的物品。如鲜鱼、鲜肉等。<br>
<br>
5、妨碍公共卫生的物品。如尸骨（包括已焚化的骨灰）、未经硝制的兽皮、未经药制的兽骨等。<br>
<br>
6、反动报刊书籍、宣传品和淫秽或有伤风化的物品。如带有法论功字样的宣传品、淫秽色情书籍、报刊、杂志等。<br>
<br>
7、各种活的动物（但蜜蜂、水蛭、蚕以及医药卫生科学研究机构封装严密并出具证明交寄的寄生虫以及供作药物或用以杀灭害虫的虫类，不在此限）。<br>
<br>
<strong>6.包装尺寸要求</strong><br>
<br>
（1）单件最大尺寸：长、宽、厚合计不超过90 厘米，最长一边不超过60 厘米。圆卷邮件直径的两倍和长度合计不超过104 厘米，长度不得超过90 厘米。<br>
<br>
(2) 单件最小尺寸：长度不小于14 厘米，宽度不小于11 厘米。圆卷邮件直径的两倍和长度合计不小于17 厘米，长度不小于11 厘米。<br>
<br>
<strong>7.揽收、自送仓库地址及联系人</strong><br>
<br>
(1) 上门揽收区域：暂无；<br>
<br>
(2) 自送&amp;揽收仓库地址：郑州市管城回族区二里岗南街487号中国邮政跨境电商产业园院内仓库16号门<br>
<br>
收货人：郑迎翔<br>
<br>
联系方式：15817301105<br>
<br>
<strong>7，丢失赔付标准</strong><br>
<br>
国内丢失赔付 ：退运费+RMB60/kg ；<br>
<br>
<strong>8.注意：</strong><br>
<br>
德国路向暂只接受申报价值不超过22欧元的包裹。<br>
<br>
巴西路向50美金以上货物需提供税号（CNPJ或CPF）。<br>
<br>
</div>` },
        {
          _id: 'e1d1466dddbc43c5ae29d71b64197549', cat: '正博新闻', title: '河南省商贸流通业第一批96家“四保”企业 | 名单', createdAt: '2022-05-31 21:59:09', content: `<div class="newsContent" style="">
            <p><b>【大河财立方消息】</b>根据河南省常态化疫情防控下经济运行调度机制指挥部办公室关于印发《河南省第一批“四保”企业（项目）白名单》的通知，5月31日，省商务厅将商贸流通业第一批“四保”企业省级白名单公布如下：</p><p><strong>一、大型农批农贸市场（23家）</strong></p><p>河南万邦国际农产品物流股份有限公司、河南中原四季水产物流港股份有限公司、河南增益信基供应链有限公司、郑州街邻鲜生实业有限公司（十八里河农产品配送中心）、开封宏进农副产品批发市场有限公司、洛阳通河农副产品有限公司、洛阳宏进农副产品批发市场有限公司、郏县汝炯农副产品市场管理有限公司、河南内黄果蔬城有限公司、鹤壁市四季青农产品批发市场、新乡市牧绿菜业股份有限公司、焦作市芦堡农副产品交易市场有限公司、濮阳厚疆农产品批发市场有限公司、许昌鲜之达农产品物流有限公司、河南鸿茂农副产品贸易有限公司、三门峡涧南农贸批发市场、南阳中商农产品批发市场开发有限公司、商丘农产品中心批发市场、信阳市裕农农产品销售有限公司、黄淮农产品股份有限公司、周口久鸿农贸市场开发有限公司、驻马店众信农副产品综合批发市场有限公司、济源市南街集贸中心</p><p><strong>二、商超企业（45家）</strong></p><p>郑州丹尼斯百货有限公司、永辉超市河南有限公司、河南丹尼斯百货有限公司、郑州市全日鲜生活便利店有限公司（丹尼斯郑州便利店）、河南世纪联华超市有限公司、河南悦来悦喜商贸有限公司、郑州大润发商业有限公司、陕西华润万家生活超市有限公司郑州分公司、河南鲜风商业连锁有限公司、开封润泰商业有限公司、河南大张实业有限公司、洛阳丹尼斯量贩有限公司、洛阳汉华商贸有限公司（丹尼斯洛阳便利店）、郏县华联商贸有限公司、安阳市圣君实业有限公司、安阳市华联优品超市连锁有限公司、河南省裕隆时代百货有限公司、新乡凯德商用置业有限公司、新乡市平原商场有限责任公司、新乡市百货大楼有限责任公司、新乡市胖东来生活广场有限公司、焦作市百货大楼有限责任公司、焦作王府井百货有限责任公司、焦作新亚商厦有限责任公司、百姓量贩有限公司、隆祥超市有限公司、绿城商贸发展有限公司、许昌市胖东来超市有限公司、许昌新大新商贸集团有限公司、河南任峰商贸有限公司（一峰超市）、漯河双汇商业连锁有限公司、漯河市物美廉商贸有限公司、河南易事多便利店连锁有限公司、河南美道家实业有限公司、南阳市万德隆商贸有限责任公司、南阳大统百货金玛特商贸有限公司、南阳市禄康源百货有限公司、永城金博大购物广场有限公司、西亚和美商业股份有限公司、信阳百家商业股份有限公司、河南悦合商业运营管理有限公司、河南万果园实业集团有限公司、欢乐爱家超市有限公司、驻马店市喜盈门商业有限公司、济源大润发商业有限公司</p><p><strong>三、电商平台企业（28家）</strong></p><p>阿里巴巴（河南）有限公司、河南京邦达供应链有限公司、北京三快在线科技有限公司河南分公司（美团）、上海禹璨信息技术有限公司河南分公司（拼多多）、河南中钢网科技集团股份有限公司、河南淘钢电子商务有限公司（淘钢网）、河南苏宁易购销售有限公司、郑州时空隧道信息技术有限公司、河南省聚爱数字科技有限公司、河南农购信息科技有限公司（农购网）、河南省新华书店发行集团有限公司（云书网）、中大门国际物流服务有限公司、<b>河南正博电子商务有限公司</b>、郑州云际跨境电商有限公司、唯品会（中国）有限公司、郑州自贸达供应链管理有限公司、郑州浩瑞供应链管理有限公司、河南邦特涞斯供应链管理有限公司、河南桂格电子商务有限公司、郑州品集供应链管理有限公司、郑州港人科技有限公司、医信通达供应链管理服务（郑州）有限公司、郑州易纳购科技有限公司、河南龙库供应链管理有限公司、河南跃菲扬电子商务有限公司、河南宸一供应链管理有限公司、河南天之航电子商务有限公司、河南云速通外贸综合服务有限公司</p></div>`}
      ],
      news: {},
    };
  },
  activated() {
    console.log("NewsDetail-activated");
    this.news = {};
    this.getdata();
  },
  methods: {
    getdata() {
      // this.$api
      //   .doAPI({
      //     Action: "web_NewsDetail",
      //     Data: {
      //       newsId: this.$route.query.id,
      //     },
      //   })
      //   .then((res) => {
      //     if (res.code === 0) {
      //       this.news = res.data.news;
      //     } else {
      //       console.log(res.msg);
      //     }
      //   })
      //   .catch((err) => {
      //     console.error(err);
      //   });
      this.news = this.list.find((item) => {
        return item._id === this.$route.query.id;
      });
    },
    goto(path) {
      if (this.$route.path === path) return;
      this.$router.push({ path });
    },
  },
};
</script>
<style scoped>
.page {
  background-color: #e2e2e2;
}

.content {
  background-color: #fff;
  border-radius: 10px;
}

.content .head {
  padding: 20px 0 10px 0;
  border-bottom: 1px solid #ddd;
}

.content .subtitle {
  font-size: 35px;
  font-weight: 600;
}

.content .info {
  padding: 20px 0;
}

.info>>>img {
  width: 100%;
}
</style>